module.exports = __webpack_public_path__ + "static/media/mail.5c1ea8bd.png";